import { message } from "antd";
import { decryptData } from "./scriptEncryption";

export function appendAnalyticsScript(scriptData) {
	let scriptResponse = scriptData.scriptText;

	if (scriptData.activate) {
		const scriptAdd = document.createElement("script");
		scriptAdd.async = true;

		// Wait for the DOM to be fully loaded
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () =>
				appendScript(scriptAdd, scriptData),
			);
		} else {
			appendScript(scriptAdd, scriptData); // DOM is already ready
		}
	}
}

function appendScript(scriptAdd, scriptData) {
	let scriptResponse = scriptData.scriptText;
	let scripts = document.querySelectorAll("script"); // Get all <script> tags in the document
	// Handle external script
	if (scriptData.scriptType === "external") {
		let srcMatch = scriptResponse.match(/src="([^"]+)"/);
		const scriptSrc = srcMatch ? srcMatch[1] : scriptResponse;

		// Remove any existing script with the same src
		scripts.forEach((script) => {
			if (script.src && script.src.includes(scriptSrc)) {
				script.remove();
			}
		});

		// Set the script src
		scriptAdd.src = scriptSrc;
	} else {
		// Handle inline script
		let tagContent = scriptResponse.match(/<script.*?>([\s\S]*?)<\/script>/i);
		// Remove any existing inline script with the same content
		if (scripts) {
			scripts.forEach((script) => {
				if (script.innerHTML.includes(scriptResponse)) {
					script.remove();
				}
			});

			// Set the inline script content
			scriptAdd.textContent = scriptResponse;
		} else {
			// If no <script> tags are found, treat it as plain JavaScript
			scriptAdd.textContent = scriptResponse;
		}
	}

	// Append the script to either head or body based on placement
	if (scriptAdd) {
		// Check if scriptAdd is a valid <script> element and has content or src
		if (
			scriptAdd instanceof HTMLScriptElement &&
			(scriptAdd.src || scriptAdd.textContent)
		) {
			try {
				// Check if script content has mismatched quotes or other obvious issues
				const scriptContent = scriptAdd.src
					? scriptAdd.src
					: scriptAdd.textContent
					? scriptAdd.textContent
					: "" || "";

				// Basic validation (you can extend this to match specific syntax rules)
				if (scriptAdd.textContent && !isValidScript(scriptContent)) {
					throw new Error("Invalid script content or syntax error.");
				}

				// If placement is head, append to head; otherwise, append to body
				if (scriptData.placement === "head") {
					document.head.appendChild(scriptAdd);
				} else {
					document.body.appendChild(scriptAdd);
				}
			} catch (error) {
				console.error("Error while adding script:", error.message);
			}
		} else {
			console.error("Invalid scriptAdd element or missing src/textContent.");
		}
	} else {
		console.error("scriptAdd is not defined or not a valid script element.");
	}
}

function isValidScript(content) {
	// Check for unmatched quotes as an example of syntax validation
	const singleQuoteCount = (content.match(/'/g) || []).length;
	const doubleQuoteCount = (content.match(/"/g) || []).length;

	// If quotes are mismatched (odd number of single or double quotes), return false
	if (singleQuoteCount % 2 !== 0 || doubleQuoteCount % 2 !== 0) {
		return false;
	}

	// You can add more complex validation here if needed

	return true;
}
